/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Workout_Item_SetsInputs */

const en_us2_workout_item_sets = /** @type {(inputs: Workout_Item_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}×`)
};

const pt_br2_workout_item_sets = /** @type {(inputs: Workout_Item_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}×`)
};

const es_419_workout_item_sets = /** @type {(inputs: Workout_Item_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}×`)
};

const pt_pt2_workout_item_sets = /** @type {(inputs: Workout_Item_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}×`)
};

const fr_fr2_workout_item_sets = /** @type {(inputs: Workout_Item_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}×`)
};

const de_de2_workout_item_sets = /** @type {(inputs: Workout_Item_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}×`)
};

const it_it2_workout_item_sets = /** @type {(inputs: Workout_Item_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}×`)
};

/**
* | output |
* | --- |
* | "{count}×" |
*
* @param {Workout_Item_SetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_item_sets = /** @type {((inputs: Workout_Item_SetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Item_SetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_item_sets(inputs)
	if (locale === "es-419") return es_419_workout_item_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_item_sets(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_item_sets(inputs)
	if (locale === "de-DE") return de_de2_workout_item_sets(inputs)
	if (locale === "it-IT") return it_it2_workout_item_sets(inputs)
	return en_us2_workout_item_sets(inputs)
});
export { workout_item_sets as "workout.item_sets" }